import { render, staticRenderFns } from "./compraCerdos.vue?vue&type=template&id=2103ea3a&scoped=true"
import script from "./compraCerdos.vue?vue&type=script&lang=js"
export * from "./compraCerdos.vue?vue&type=script&lang=js"
import style0 from "./compraCerdos.vue?vue&type=style&index=0&id=2103ea3a&prod&lang=css"
import style1 from "./compraCerdos.vue?vue&type=style&index=1&id=2103ea3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2103ea3a",
  null
  
)

export default component.exports